export function filterNotMentioned(input:string) {
    return input.split('\n').filter(line => !/\[Not Mentioned\]/.test(line)).join('\n');
}
  
export function removeNotMentioned(input:string) {
    return input.split('\n').map(line => line.replace(/\[Not Mentioned\]$/, '')).join('\n');
}

export function extractFirstName(name: string) {
    const cleanedName = name
      .replace(/[^a-zA-Z\s]/g, '') // Remove non-letter characters
      .trim();                     // Remove extra whitespace
  
    return cleanedName ? cleanedName.split(/\s+/)[0] : name; // Return first word or full name if empty
}

export function toTitleCase(str:string) {
    return str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase());
}

export const capitalizeFirstLetter = (string: string) => string.charAt(0).toUpperCase() + string.slice(1);


export const SpacingText = (text:string) => {
    // New lines to HTML
    const textWithLineBreaks = text.replace(/\n/g, '<br>');
    return textWithLineBreaks
}

export function addMissingIndentLevels(htmlString: string): string {
    let indentLevel = 0;

    // Regular expression to match <li> and nested <ul>/<ol>
    const listRegex = /<\s*(\/?(?:ul|ol|li))(.*?)>/gi;

    return htmlString.replace(listRegex, (match, tagName) => {
        if (tagName === "ul" || tagName === "ol") {
            // Entering a nested list, increase indent level
            indentLevel++;
            return match;
        } else if (tagName === "/ul" || tagName === "/ol") {
            // Exiting a nested list, decrease indent level
            indentLevel = Math.max(indentLevel - 1, 0);
            return match;
        } else if (tagName === "li" && indentLevel > 1) {
            // Add ql-indent-{indentLevel-1} class to <li> tags if nested
            return match.replace(
                /<li(.*?>)/,
                `<li class="ql-indent-${indentLevel - 1}"$1`
            );
        }

        return match; // Leave the outermost <li> tags unchanged
    });
}

export function fixIndentation(html: string, removeSpacesBetweenSections: boolean): string {
    try{
        html = html.replace(/<\/ul><br\/><ul>/g, '</ul><ul>');
        html = html.replace(/<\/ul><p><br><\/p><ul>/g, '</ul><ul>');
        
        if (removeSpacesBetweenSections) {
            html = html.replace(/<p><br><\/p>/g, '');
            html = html.replace(/<\/ul><br\/><strong>/g, '</ul><strong>');
        }

        // Parse the HTML string into a DOM document
        let parser = new DOMParser();
        let doc = parser.parseFromString(html, 'text/html');

        // Process all lists in the document
        let lists = doc.querySelectorAll('ul, ol');
        lists.forEach(list => {
            fixList(list);
        });

        // Return the corrected HTML as a string
        return doc.body.innerHTML;
    }
    catch(e){
        return html;
    }
}

function fixList(list: Element) {
    let stack: Element[] = [list];
    let lastIndentLevel = 0;

    // Collect child nodes to prevent issues during DOM manipulation
    let childNodes = Array.from(list.childNodes);

    for (let node of childNodes) {
        if (node.nodeType === Node.ELEMENT_NODE && node.nodeName.toLowerCase() === 'li') {
            let li = node as Element;
            let indentLevel = getIndentLevel(li);

            if (indentLevel > lastIndentLevel) {
                // Indentation increased; create sublists as needed
                for (let i = lastIndentLevel; i < indentLevel; i++) {
                    let newList = list.ownerDocument.createElement('ul');
                    let parentLi = stack[stack.length - 1].lastElementChild;

                    if (parentLi && parentLi.nodeName.toLowerCase() === 'li') {
                        parentLi.appendChild(newList);
                        stack.push(newList);
                    } else {
                        console.error('Cannot find parent <li> to append sublist');
                        return;
                    }
                }
            } else if (indentLevel < lastIndentLevel) {
                // Indentation decreased; move back up the stack
                for (let i = lastIndentLevel; i > indentLevel; i--) {
                    stack.pop();
                }
            }

            // Remove the <li> from its current parent and append it to the correct list
            if (li.parentNode !== stack[stack.length - 1]) {
                li.parentNode?.removeChild(li);
            }
            stack[stack.length - 1].appendChild(li);
            lastIndentLevel = indentLevel;
        }
    }
}

function getIndentLevel(li: Element): number {
    // Extract the indentation level from the class name
    let indentLevel = 0;
    li.classList.forEach(cls => {
        let match = cls.match(/ql-indent-(\d+)/);
        if (match) {
            indentLevel = parseInt(match[1]);
        }
    });
    return indentLevel;
}